<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconCalendar_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M10.1 1.543v-.18C10.1.612 10.727 0 11.5 0h.14c.773 0 1.4.61 1.4 1.364v.179h.56c.77 0 1.4.606 1.4 1.346v10.765c0 .74-.63 1.346-1.4 1.346H2.4c-.77 0-1.4-.606-1.4-1.346V2.89c0-.74.63-1.346 1.4-1.346h.7v-.18C3.1.612 3.727 0 4.5 0h.14c.773 0 1.4.61 1.4 1.364v.179h4.06Zm3.5 12.111H2.4V4.907h11.2v8.747Z"
        clip-rule="evenodd"
    />
</svg>
